var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99969 4.47709C5.73969 4.73709 5.73969 5.15709 5.99969 5.41709L8.58635 8.00376L5.99969 10.5904C5.73969 10.8504 5.73969 11.2704 5.99969 11.5304C6.25969 11.7904 6.67969 11.7904 6.93969 11.5304L9.99969 8.47042C10.2597 8.21042 10.2597 7.79042 9.99969 7.53042L6.93969 4.47042C6.68635 4.21709 6.25969 4.21709 5.99969 4.47709Z",
    fill: "#6938EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron_right.c2bf4ceb719b8683437459b34121c799.svg";
export { ForwardRef as ReactComponent };